import { render } from "./MediaPreview.vue?vue&type=template&id=76af5c81&scoped=true"
import script from "./MediaPreview.vue?vue&type=script&lang=js"
export * from "./MediaPreview.vue?vue&type=script&lang=js"

import "./MediaPreview.vue?vue&type=style&index=0&id=76af5c81&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-76af5c81"

export default script